import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, HostBinding, OnChanges } from '@angular/core';
import { ValidatorUtils } from '../../shared/utils/src/validator.utils';
// export interface PageChangedEvent {
//     itemsPerPage: number;
//     currentPage: number;
// }

@Component({
    selector: 'pagination-component',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss']
})

export class PaginationComponent implements OnInit, OnChanges {

    private prevPage: number;
    private nextPage: number;
    private totalPages: number;

    private oldItemsPerPage: number;
    private oldCurrentPage: number;
    private pageChangeEvent: Boolean = false;
    private selectChangeEvent: Boolean = false;

    @Input() public paginationAlignClass: string;
    @Input() public paginationGeneral: string;
    @Input() public itemsPerPage: number;
    @Input() public selectOptions: any[];
    @Input() public totalCount: number;
    @Input() public currentPage: number;
    @Output() public pageChanged: EventEmitter<any> = new EventEmitter();
    @Output() public selectChanged: EventEmitter<any> = new EventEmitter();

    @HostBinding('attr.data-is-exist') private dataExist: boolean;

    constructor() { }


    ngOnInit() {
        this.oldItemsPerPage = this.itemsPerPage;
        this.oldCurrentPage = this.currentPage;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.totalCount > 0) {
            this.setPage(this.currentPage !== undefined ? this.currentPage : 1);
            this.dataExist = true;
        } else {    //카운트가 없으면 데이터가 없다고 찍어줘야 한다.
            this.dataExist = false;
        }
    }

    onChangeOption(event: Event) {
        const selectElement: any = event.target;
        const optionIndex: any = selectElement.selectedIndex;
        const optionValue: any = selectElement.options[optionIndex].value;

        this.itemsPerPage = Number(optionValue);

        this.setPage(1);
        this.selectChangeEvent = false;
    }

    setPage(currentPage: number = 1) {
        if (currentPage.toString() === '') {
            return;
        }

        const totalPages: number = Math.ceil(this.totalCount / this.itemsPerPage);

        let prevPage: number, nextPage: number;

        if (currentPage > totalPages) {
            currentPage = totalPages;
        }

        let isNowFirst: boolean, isNowLast: boolean;
        isNowFirst = currentPage === 1 ? true : false;
        isNowLast = currentPage === totalPages ? true : false;

        if (isNowFirst) {
            prevPage = 1;
        } else {
            prevPage = ((currentPage - 1) < 1 ? 1 : (currentPage - 1));
        }

        if (isNowLast) {
            nextPage = totalPages;
        } else {
            nextPage = ((currentPage + 1) > totalPages ? totalPages : (currentPage + 1));
            nextPage = (nextPage < 1 ? 1 : nextPage);
        }

        /*console.log('====================================');
        console.log('>>>> prevPage : ' + prevPage);
        console.log('>>>> currentPage : ' + currentPage);
        console.log('>>>> nextPage : ' + nextPage);
        console.log('>>>> itemsPerPage : ' + this.itemsPerPage);
        console.log('>>>> totalPages : ' + totalPages);
        console.log('>>>> totalCount : ' + this.totalCount);
        */
        this.prevPage = prevPage;
        this.currentPage = currentPage;
        this.nextPage = nextPage;
        this.totalPages = totalPages;

        // console.log('oldItemsPerPage >>>> : ' + this.oldItemsPerPage);
        // console.log('itemsPerPage >>>> :' + this.itemsPerPage);
        // console.log('oldCurrentPage >>>> : ' + this.oldCurrentPage);
        // console.log('currentPage >>>> : ' + this.currentPage);

        if (this.oldItemsPerPage !== this.itemsPerPage) {
            // 셀렉트 이벤트
            this.selectChanged.emit({
                itemsPerPage: this.itemsPerPage,
            });

            if (this.pageChangeEvent) {
                this.selectChangeEvent = true;
            }
        }

        if (!this.selectChangeEvent && this.oldCurrentPage !== undefined && this.oldCurrentPage !== this.currentPage) {
            // 페이지 이동 이벤트
            this.pageChanged.emit({
                currentPage: this.currentPage
            });

            this.pageChangeEvent = true;
        }

        this.oldCurrentPage = this.currentPage;
        this.oldItemsPerPage = this.itemsPerPage;
    }

    onlyNumber(event) {
        return ValidatorUtils.onlyNumber(event);
    }

    removeChar(event) {
        ValidatorUtils.removeChar(event);
        this.currentPage = Number(event.target.value);
    }

    checkMinMax(event) {
        ValidatorUtils.checkNumberValidation(event);
        this.currentPage = Number(event.target.value);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/pagination/pagination.component.ts